import {
  BackofficePrestation,
  GetPrestations,
  Paginated,
  PaginatedResponse,
  Searchable,
  Sortable,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import { prestationsQueryKeys } from "../query-keys/prestations.query-keys";

async function getPrestations() {
  const { data } = await privateAxios.get<GetPrestations>("/prestations");
  return data;
}

export function useGetPrestations() {
  return useQuery({
    queryKey: prestationsQueryKeys.all,
    queryFn: getPrestations,
  });
}

const THIRTY_MINUTES = 30 * 60 * 1000;

export function useGetPrestationsNames() {
  return useQuery({
    queryKey: prestationsQueryKeys.names(),
    queryFn: getPrestations,
    staleTime: THIRTY_MINUTES,
    gcTime: THIRTY_MINUTES,
  });
}

async function getPrestationsList(filters: Sortable<Paginated<Searchable>>) {
  try {
    const { data } = await privateAxios.get<
      PaginatedResponse<BackofficePrestation>
    >("/prestations/list", {
      params: filters,
    });
    return data;
  } catch (error) {
    if (isAxiosError(error)) error.message = error.response?.data.message;
    throw error;
  }
}

interface UseGetPrestationsListOptions {
  enabled?: boolean;
}

export function useGetPrestationsList(
  filters: Sortable<Paginated<Searchable>>,
  options?: UseGetPrestationsListOptions
) {
  return useQuery({
    queryKey: prestationsQueryKeys.list(filters),
    queryFn: () => getPrestationsList(filters),
    enabled: options?.enabled,
  });
}
